module.exports = __webpack_public_path__ + "img/qilin-stage2-blink.a8d5ff53.png";